import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Amplify } from 'aws-amplify';
import amplifyconfig from './amplifyconfiguration.json';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store';
import { CssBaseline } from '@mui/material';
import { ThemeContextProvider } from './theme/ThemeContext';
import GlobalStylesWrapper from './theme/GlobalStylesWrapper';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { clearBrowserDatabase } from './helpers/utils';
Amplify.configure(amplifyconfig);
/*
 * This part will run with every refresh
 * Check version, And empty cache in case there is new version deployed
 */
clearBrowserDatabase();
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeContextProvider>
        <CssBaseline />
        <GlobalStylesWrapper />
        <BrowserRouter>
          <ScrollToTop />
          <App />
        </BrowserRouter>
      </ThemeContextProvider>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
